// ============================================
// FILE: src/components/DesktopFooter.jsx
// Shared footer used across all desktop (>=1024px) pages.
// ============================================

import React from 'react';

const DesktopFooter = ({
  appSettings,
  setActiveTab,
  setShowFavorites,
  setSelectedCategory,
  onOpenOffers,
}) => {
  const logoSrc = `${process.env.PUBLIC_URL || ''}/logo.png`;
  const go = (tab) => () => setActiveTab && setActiveTab(tab);

  return (
    <footer className="bg-white border-t border-gray-200 mt-8">
      <div className="max-w-[1280px] mx-auto px-8 py-12 grid grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={logoSrc} alt="logo" className="w-9 h-9 rounded-xl object-contain" />
            <h3 className="app-brand-title text-lg" style={{ color: '#1b1b1b' }}>{appSettings?.appName || 'DealStore'}</h3>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed">Fresh picks &amp; daily savings delivered to your door.</p>
        </div>
        <div>
          <h4 className="text-sm font-bold text-gray-800 mb-3">Shop</h4>
          <ul className="space-y-2 text-sm text-gray-500">
            <li><button onClick={() => { setSelectedCategory && setSelectedCategory('All'); setActiveTab && setActiveTab('home'); }} className="hover:text-orange-500">All Products</button></li>
            <li><button onClick={() => onOpenOffers && onOpenOffers('all')} className="hover:text-orange-500">Offers</button></li>
            <li><button onClick={go('subscriptions')} className="hover:text-orange-500">Subscriptions</button></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold text-gray-800 mb-3">Account</h4>
          <ul className="space-y-2 text-sm text-gray-500">
            <li><button onClick={go('orders')} className="hover:text-orange-500">My Orders</button></li>
            <li><button onClick={() => setShowFavorites && setShowFavorites(true)} className="hover:text-orange-500">Favorites</button></li>
            <li><button onClick={go('profile')} className="hover:text-orange-500">Profile</button></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold text-gray-800 mb-3">Help</h4>
          <ul className="space-y-2 text-sm text-gray-500">
            <li><button onClick={go('about')} className="hover:text-orange-500">About Us</button></li>
            <li><button onClick={go('help')} className="hover:text-orange-500">Help &amp; Support</button></li>
            <li><button onClick={go('terms')} className="hover:text-orange-500">Terms</button></li>
            <li><button onClick={go('privacy')} className="hover:text-orange-500">Privacy Policy</button></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-100">
        <div className="max-w-[1280px] mx-auto px-8 py-5 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} {appSettings?.appName || 'DealStore'}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;
